module.exports = __webpack_public_path__ + "img/1505672581.261898c0.jpg";